<template>
  <section id="services" class="features-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="status-card">
            <div class="status-header">
              <h2>Flood Status Report</h2>
            </div>
            <div class="status-body">
              <table class="status-table">
                <tr>
                  <th>Building</th>
                  <td>{{ floodData.user_flat_data.building }}</td>
                </tr>
                <tr>
                  <th>Floor</th>
                  <td>{{ floodData.user_flat_data.floor }}</td>
                </tr>
                <tr>
                  <th>Reported By</th>
                  <td>{{ floodData.user_flat_data.name }}</td>
                </tr>
                <tr>
                  <th>Contact</th>
                  <td>{{ floodData.user_flat_data.mobile_number }}</td>
                </tr>
                <tr>
                  <th>Reported Time</th>
                  <td>{{ floodData.created_at }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td :class="statusClass">{{ resolveStatus }}</td>
                </tr>
              </table>
              <div class="status-image">
                <img :src="floodData.flood_image" width="200" alt="Flood Image" v-if="floodData.flood_image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
  },
  data() {
    return {
      floodData: {}
    };
  },
  methods: {
    ...mapActions({
      getFloodAlarm: "appData/getFloodAlarm",
    }),
  },
  computed: {
    statusClass() {
      return {
        'status-moderate': this.floodData.resolve_status === false,
        'status-severe': this.floodData.resolve_status === true
      };
    },
    resolveStatus() {
      return this.floodData.resolve_status ? "Resolved" : "Pending";
    },
  },
  
  async mounted() {
    const floodId = this.$route.query.id;
    const flood_alarm = await this.getFloodAlarm({ pk : floodId });
    this.floodData = flood_alarm.data;
  }
};
</script>

<style>
h2{
  color: black;
}
.features-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #eeb61e, #febc03);
  color: rgb(0, 0, 0);
}
.container {
  max-width: 60vw;
}
.status-card {
  background: rgba(255, 255, 255, 0.9);
  padding: 60px;
  border-radius: 15px;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
  transition: transform 0.3s ease-in-out;
}
.status-card:hover {
  transform: scale(1.05);
}
.status-header {
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: bold;
}
.status-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.status-info p {
  margin: 8px 0;
  font-size: 1.1rem;
}
.status-image img {
  max-width: 100%;
  border-radius: 10px;
  margin-top: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
}
.status-mild {
  color: green;
  font-weight: bold;
}
.status-moderate {
  color: orange;
  font-weight: bold;
}
.status-severe {
  color: red;
  font-weight: bold;
  animation: blink 1s infinite alternate;
}
.status-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}
.status-table th, .status-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}
.status-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}
@keyframes blink {
  from { opacity: 1; }
  to { opacity: 0.5; }
}
</style>
